// @flow
import React from "react";
import AccountCard from "./Account/Card";
import TournamentCard from "./TournamentCard";
import type { Tournament as TournamentProps } from "../../redux/CommonTypes";

type Props = TournamentProps & {
  layout?: "vertical" | "horizontal"
};

export default function Card({ layout, ...props }: Props) {
  switch (layout) {
    case "vertical":
      return <AccountCard {...props} />;
    case "horizontal":
    default:
      return <TournamentCard {...props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Tournaments/Card.js